// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"725":"98bef5de","805":"cd97a040","828":"menu-items-svg"}[chunkId] || chunkId) + "." + {"184":"ae96676c5aeb2a8c","580":"2d4ed79dd59dd0b0","725":"d347369778872938","805":"69c61cc3e4ebfc5b","828":"7c3b40a6381e0d3b"}[chunkId] + ".js";
};